'use client';

import { usePathname } from 'next/navigation';
import { Header, Footer } from '@/components/common';
import ReduxProvider from '@/redux/provider';
import { AnalyticsProvider } from '@/providers';
import ScrollRestoration from '../../scrollRestoration/scrollRestoration.component';

interface TProps {
  font: any;
  children: React.ReactNode;
}

export default function PageWrapper({ children }: TProps) {
  const pathname = usePathname();
  const showHeaderFooter = !pathname.startsWith('/curiobit');

  return (
    <ReduxProvider>
      <AnalyticsProvider>
        <ScrollRestoration />
        {showHeaderFooter && <Header />}
        <main className='bg-white'>{children}</main>
        {showHeaderFooter && <Footer />}
      </AnalyticsProvider>
    </ReduxProvider>
  );
}
